export default __webpack_public_path__ + "static/media/dtt.6109d345.png";